import {lazyRegister} from "@/Core/lazyRegister";

lazyRegister.filter('dateFormat', function () {
    return function (input, options) {
        if (!input ||
            (typeof input == 'string' &&
                (input.includes('0001') || input.includes('1970-01-01'))
            )
        ) {
            return "";
        }

        try {
            const date = new Date(input);
            if (isNaN(date.getTime())) return input;

            const formatString = (options && options.format) ? options.format : 'YYYY-MM-DD';

            const pad = (num) => (num < 10 ? '0' + num : num);

            const map = {
                'YYYY': date.getFullYear(),
                'MM': pad(date.getMonth() + 1),
                'DD': pad(date.getDate()),
                'HH': pad(date.getHours()),
                'mm': pad(date.getMinutes()),
                'ss': pad(date.getSeconds())
            };

            return formatString.replace(/YYYY|MM|DD|HH|mm|ss/g, (matched) => map[matched]);
        } catch (e) {
            console.warn('Format date error', e)
            return input;
        }
    };
});
